<template>

	<div class="preHeader">
		<h3 style="color:#FBFBFF">
			Unlock the timeless wisdom of Vedic astrology with personalized birth chart reports and expert interpretations tailored to your life. 
        	Explore your unique cosmic blueprint with detailed insights into your Planetary Positions, House Analysis, Nakshatra Influence, and Mahadasha Analysis. 
        	Guided by ancient wisdom and designed for modern self-discovery — your personal astrology journey starts here, all at your fingertips.			
		</h3>
	</div>

	<div class="screen-wrapper">

        <div v-if="menuItem == 'home'"> 
            <ChartBasicCriteria @horoscope="setHoroscope" :userSelectedChartStyle="userSelectedChartStyle" />
        </div>

        <div v-if="menuItem == 'chart'"> 
            <ChartResult :horoscope="horoscope" @horoscope="setHoroscope" @userSelectedChartStyle="setUserSelectedChartStyle" @activeMenuItem="activateMenuItem" />
        </div>

        <div v-if="menuItem == 'free-report'"> 
            <FreeReportReader :horoscope="horoscope" @activeMenuItem="activateMenuItem" />
        </div>

        <div v-if="menuItem == 'paid-report'"> 
            <PaidReports  @activeMenuItem="activateMenuItem" />
        </div>

        <div v-if="menuItem == 'purchase-planetary-positions-report'"> 
            <PurchasePlanetaryPositionsReport :horoscope="horoscope" @activeMenuItem="activateMenuItem" />
        </div>

        <div v-if="menuItem == 'purchase-house-analysis-report'"> 
            <PurchaseHouseAnalysisReport :horoscope="horoscope" @activeMenuItem="activateMenuItem" />
        </div>

        <div v-if="menuItem == 'purchase-nakshatra-influence-report'"> 
            <PurchaseNakshatraInfluenceReport :horoscope="horoscope" @activeMenuItem="activateMenuItem" />
        </div>

        <div v-if="menuItem == 'purchase-mahadasha-analysis-report'"> 
            <PurchaseMahadashaAnalysisReport :horoscope="horoscope" @activeMenuItem="activateMenuItem" />
        </div>

        <div v-if="menuItem == 'purchase-all-reports'"> 
            <PurchaseAllReports :horoscope="horoscope" @activeMenuItem="activateMenuItem" />
        </div>

	</div>


</template>

<script>
import ChartBasicCriteria from '@/components/ChartBasicCriteria'
import ChartResult from '@/components/ChartResult'
import FreeReportReader from '../components/FreeReportReader.vue'
import PaidReports from '../components/PaidReports.vue'
import PurchasePlanetaryPositionsReport from '../components/PurchasePlanetaryPositionsReport.vue'
import PurchaseHouseAnalysisReport from '../components/PurchaseHouseAnalysisReport.vue'
import PurchaseNakshatraInfluenceReport from '../components/PurchaseNakshatraInfluenceReport.vue'
import PurchaseMahadashaAnalysisReport from '../components/PurchaseMahadashaAnalysisReport.vue'
import PurchaseAllReports from '../components/PurchaseAllReports.vue'


export default {
	components: { ChartBasicCriteria, ChartResult, FreeReportReader, PaidReports, PurchasePlanetaryPositionsReport, 
		PurchaseHouseAnalysisReport, PurchaseNakshatraInfluenceReport, PurchaseMahadashaAnalysisReport, PurchaseAllReports
	 },
	data() {
		return {
			menuItem: 'home',
			horoscope: {},
			userSelectedChartStyle: 0
		}
	},
	mounted() {
	},	
	beforeUnmount() { 
	},
	methods: {
		setHoroscope( horoscope ) {
			this.horoscope = horoscope
			this.menuItem = 'chart'
		},
		setUserSelectedChartStyle( newChartStyle ) {
			this.userSelectedChartStyle = newChartStyle
		},
		activateMenuItem( activeMenuItem ) {
			this.menuItem = activeMenuItem;
		},
	}
}
</script>

<style scoped>

.preHeader {
	display:none !important;
	visibility: hidden !important;
	color: #FBFBFF !important;
	text-align: center;
}      

.screen-wrapper {
    border: 0px solid;
}

@media (max-width: 500px) {

    .screen-wrapper {
        border: 0px solid;
    }  
}

</style>
